module.exports = __webpack_public_path__ + "ba76fd95ced6e3acf986f93cfc1795f6.png";